import { useCallback, useMemo } from 'react'
import CuratedPhotosHeader from '../components/CuratedPhotosHeader'
import DPFFaqJpSection from '../components/DPFFaqJpSection'
import EaseOfUseSection from '../components/EaseOfUseSection'
import EmotionalClosingSection from '../components/EmotionalClosingSection'
import Footer from '../components/Footer'
import HeroSection from '../components/HeroSection'
import MemoriesSection from '../components/MemoriesSection'
import MessageSection from '../components/MessageSection'
import ProductPricingSection from '../components/ProductPricingSection'
import PurchaseButtons from '../components/PurchaseButtons'
import PurchaseStepsSection from '../components/PurchaseStepsSection'
import SharingMemoriesSection from '../components/SharingMemoriesSection'
import UsageScenesSection from '../components/UsageScenesSection'
import { useAppContext } from '../contexts/AppContext'
import useTracking from '../hooks/useTracking'
import { getHeaderType } from '../utils/headerType'

export default function LandingPage() {
  const { isPremiumUser = false, userPhotos = [], premiumDeepLinkUrl = '', api } = useAppContext()
  const isUsingFallback = userPhotos.length === 0

  const {
    logClickedBuyOnAmazon,
    logClickedBuyOnRakuten,
    logClickedLearnMoreAboutPremium,
    logClickedPurchaseStepsButtonAmazon,
    logClickedPurchaseStepsButtonRakuten,
  } = useTracking({ api: api || null })

  const handleBuyOnAmazonClick = useCallback(() => {
    logClickedBuyOnAmazon()
  }, [logClickedBuyOnAmazon])

  const handleBuyOnRakutenClick = useCallback(() => {
    logClickedBuyOnRakuten()
  }, [logClickedBuyOnRakuten])

  const headerType = useMemo(() => getHeaderType(), [])

  const showNewYearBanner = useMemo(() => {
    return headerType === 'new-year'
  }, [headerType])

  return (
    <>
      <header className='relative'>
        <CuratedPhotosHeader curatedPhotos={userPhotos} isUsingFallback={isUsingFallback} />
      </header>

      {showNewYearBanner && (
        <div className='bg-[#EA5153] py-3 text-center text-white flex items-center justify-center gap-2'>
          <span className='text-[#EA5153] text-[12px] leading-[154%] leading-[11%] gap-[10px] bg-white px-2 py-0.5 rounded-[40px] font-extrabold'>
            新発売
          </span>
          {'  '}
          <span className='font-bold'>2025年を家族で振り返りませんか?</span>
        </div>
      )}

      <MessageSection />
      <HeroSection />
      <SharingMemoriesSection />
      <EaseOfUseSection />

      <ProductPricingSection
        isPremiumUser={isPremiumUser}
        premiumDeepLinkUrl={premiumDeepLinkUrl}
        logClickedLearnMoreAboutPremium={logClickedLearnMoreAboutPremium}
      />
      <PurchaseStepsSection
        logClickedPurchaseStepsButtonAmazon={logClickedPurchaseStepsButtonAmazon}
        logClickedPurchaseStepsButtonRakuten={logClickedPurchaseStepsButtonRakuten}
      />

      <UsageScenesSection />
      <MemoriesSection curatedPhotos={[]} isUsingFallback={true} />
      <EmotionalClosingSection />
      <DPFFaqJpSection />

      <Footer />

      <PurchaseButtons onAmazonClick={handleBuyOnAmazonClick} onRakutenClick={handleBuyOnRakutenClick} />
    </>
  )
}
